import request from "@/utils/request"

/**
 * 获取我的拍卖列表
 * @param {*} params {status:2 持有 2 申请 1 结清 3
            investType: 2 投资类型 1-债券类型 2-拍卖类型
            pageNo: 1
            pageSize: 10}
 * @returns 
 */
export function getAuctionInvestlist(params) {
    return request.post('/pay/getAuctionInvestlist', params)
}

/**
 * 获取我的拍卖详情
 * @param {*} params {status:2 持有 2 申请 1 结清 3 investId: 拍卖ID}
 * @returns 
 */
export function getAuctionInvestDetail(params) {
    return request.post('/pay/getAuctionInvestDetail', params)
}

/**
 * 撤销我的拍品
 * @param {*} nvestId 拍卖ID
 * @returns 
 */
 export function cancelAuctionInvest(investId) {
     return request.post('/pay/cancelAuctionInvest', { investId: investId })
}